import Rails from '@rails/ujs';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';

export default class MoeSlotPicker {
  constructor() {
    this.calendar = null;
    this.pickerState = {
      actionId: null,
      submitUrl: null,
      eventsUrl: null,
      selectedSlotId: null,
      selectedStart: null,
      selectedEnd: null
    };
    this.bindEvents();
    this.bindModalEvents();
  }

  bindEvents() {
    $(document).on('click', '.moe-plan-btn', (e) => this.onPlanClick($(e.currentTarget), 'plan'));
    $(document).on('click', '.moe-reschedule-btn', (e) => this.onPlanClick($(e.currentTarget), 'reschedule'));
    $('#moeSlotPickerConfirm').on('click', () => this.submitSlotSelection());
  }

  bindModalEvents() {
    $('#moeSlotPickerModal').on('shown.bs.modal', () => {
      if (!this.calendar) {
        this.initCalendar();
      } else {
        this.calendar.updateSize();
        this.calendar.refetchEvents();
      }
    });

    $('#moeSlotPickerModal').on('hidden.bs.modal', () => {
      this.pickerState.selectedSlotId = null;
      this.pickerState.selectedStart = null;
      this.pickerState.selectedEnd = null;
      $('#moeSlotPickerConfirm').prop('disabled', true);
      $('#moeSlotPickerError').addClass('d-none');
    });
  }

  onPlanClick(btn, mode) {
    this.pickerState.actionId = btn.data('action-id');
    this.pickerState.eventsUrl = btn.data('events-url');
    this.pickerState.submitUrl = mode === 'reschedule' ? btn.data('reschedule-url') : btn.data('plan-url');

    const title = mode === 'reschedule' ? "Replanifier l'action" : "Planifier l'action";
    $('#moeSlotPickerTitle').text(title);
    $('#moeSlotPickerError').addClass('d-none');
    $('#moeSlotPickerConfirm').prop('disabled', true);
    $('#moeSlotPickerModal').modal('show');
  }

  initCalendar() {
    const calendarEl = document.getElementById('moeSlotPickerCalendar');
    if (!calendarEl) return;

    this.calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin, timeGridPlugin],
      initialView: 'dayGridMonth',
      locale: 'fr',
      timeZone: 'Europe/Paris',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      buttonText: {
        today: "Aujourd'hui",
        month: 'Mois',
        week: 'Semaine',
        day: 'Jour'
      },
      slotMinTime: '07:00:00',
      slotMaxTime: '20:00:00',
      allDaySlot: false,
      height: 'auto',
      events: (info, successCb, failureCb) => {
        const url = new URL(this.pickerState.eventsUrl, window.location.href);
        url.searchParams.set('start', info.startStr);
        url.searchParams.set('end', info.endStr);
        fetch(url, { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(r => r.json())
          .then(data => successCb(data.map(e => this._markIfPastDay(e))))
          .catch(err => failureCb(err));
      },
      eventClick: (info) => {
        if (info.event.extendedProps.type !== 'availability') return;
        if (info.event.extendedProps.pastDay) return;
        this.pickerState.selectedSlotId = info.event.extendedProps.slot_id;
        this.pickerState.selectedStart = info.event.startStr;
        this.pickerState.selectedEnd = info.event.endStr;
        this.calendar.getEvents().forEach(e => e.setProp('backgroundColor', null));
        info.event.setProp('backgroundColor', '#1abc9c');
        $('#moeSlotPickerConfirm').prop('disabled', false);
      }
    });

    this.calendar.render();
  }

  submitSlotSelection() {
    if (!this.pickerState.selectedSlotId) return;
    $('#moeSlotPickerConfirm').prop('disabled', true);
    const data = new URLSearchParams({
      action_execution_id: this.pickerState.actionId,
      moe_slot_id: this.pickerState.selectedSlotId,
      starts_at: this.pickerState.selectedStart || '',
      ends_at: this.pickerState.selectedEnd || '',
      authenticity_token: $('meta[name="csrf-token"]').attr('content')
    }).toString();
    Rails.ajax({
      url: this.pickerState.submitUrl,
      type: this.pickerState.submitUrl.includes('reschedule') ? 'PUT' : 'POST',
      data,
      success: (resp) => {
        if (resp.success) {
          $('#moeSlotPickerModal').modal('hide');
          location.reload();
        } else {
          $('#moeSlotPickerError').text(resp.error).removeClass('d-none');
          $('#moeSlotPickerConfirm').prop('disabled', false);
        }
      },
      error: (xhr) => {
        const msg = xhr && xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Erreur serveur';
        $('#moeSlotPickerError').text(msg).removeClass('d-none');
        $('#moeSlotPickerConfirm').prop('disabled', false);
      }
    });
  }

  _markIfPastDay(event) {
    if (event.extendedProps?.type !== 'availability') return event;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (new Date(event.start) >= today) return event;
    return { ...event, color: '#f0ad4e', title: 'Date passée', extendedProps: { ...event.extendedProps, pastDay: true } };
  }

  onDestroy() {
    $(document).off('click', '.moe-plan-btn');
    $(document).off('click', '.moe-reschedule-btn');
    $('#moeSlotPickerConfirm').off('click');
    $('#moeSlotPickerModal').off('shown.bs.modal hidden.bs.modal');
    if (this.calendar) {
      this.calendar.destroy();
      this.calendar = null;
    }
  }
}
